import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { standingsAPI } from '../services/api';
import SEOHead from '../components/SEOHead';

const Standings = () => {
  const { data: standings = [], isLoading } = useQuery({
    queryKey: ['standings'],
    queryFn: () => standingsAPI.getAll().then((r) => r.data),
  });

  if (isLoading) {
    return (
      <>
        <SEOHead
          title="2026 FIFA World Cup Standings - WorldCup Fan Planner"
          description="Live group tables and standings for the 2026 FIFA World Cup—points, goals, and qualification picture."
        />
        <div className="p-8 text-center">Loading...</div>
      </>
    );
  }

  const byGroup = standings.reduce((acc, row) => {
    const g = row.group_name || 'General';
    if (!acc[g]) acc[g] = [];
    acc[g].push(row);
    return acc;
  }, {});

  return (
    <>
      <SEOHead
        title="2026 FIFA World Cup Standings - WorldCup Fan Planner"
        description="Live group tables and standings for the 2026 FIFA World Cup—points, goals, and qualification picture."
      />
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Group Standings</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-6">FIFA World Cup 2026 group tables</p>

      {Object.keys(byGroup).length === 0 && (
        <div className="rounded-xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 p-8 text-center text-gray-500 dark:text-gray-400">
          No standings yet. Run the API-Football sync to fetch data.
        </div>
      )}

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Object.entries(byGroup).map(([groupName, rows]) => (
          <div
            key={groupName}
            className="rounded-xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 overflow-hidden"
          >
            <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
              <h2 className="font-bold text-gray-900 dark:text-white">{groupName}</h2>
            </div>
            <div className="divide-y divide-gray-100 dark:divide-gray-700">
              {rows.map((r) => (
                <div
                  key={r.id}
                  className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700/30"
                >
                  <div className="flex items-center gap-3">
                    <span className="font-mono text-sm text-gray-500 dark:text-gray-400 w-6">{r.rank}</span>
                    {r.team_logo && (
                      <img src={r.team_logo} alt="" className="h-6 w-6 object-contain" />
                    )}
                    <span className="font-medium text-gray-900 dark:text-white">{r.team_name}</span>
                  </div>
                  <div className="flex gap-4 text-sm">
                    <span className="text-amber-600 dark:text-amber-400 font-bold">{r.points || 0}</span>
                    <span className="text-gray-500 dark:text-gray-400 w-12 text-right">{r.goals_diff ?? '-'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Standings;
